var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade-loading"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"loading"},[_c('i-spin',{attrs:{"size":"large","fix":""}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }